import Link from '../../views/Link2approvepage';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  intl: ownProps.match.params.intl,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  membername: state.shift.assessment.membername,
  memberusername: state.shift.assessment.memberusername,
  memberemail: state.shift.assessment.memberemail,
  membertelephone: state.shift.assessment.membertelephone,
  memberrole: state.shift.assessment.memberrole,
  memberstatus: state.shift.assessment.memberstatus,
  popwindow: state.shift.status.popwindow,
  role: state.shift.auth.role
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    getuser: username => {
      console.log('I am approbe:');
      dispatch(actions.getuser(username)).then(() =>
  dispatch(push(`/${locale}/approve`))           // CR add internal account approver go to new page orignial is /${locale}//approve  
);
    },

    getuserfordata: username => {
      
      dispatch(actions.getuser(username)).then(() =>
  dispatch(push(`/${locale}/approvedata`))           // CR add internal account approver go to new page orignial is /${locale}//approve  
);
    }
  };
};

const Link2approvepage = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Link2approvepage;



// WEBPACK FOOTER //
// ./src/components/container/Link2approvepage/index.js